import React from 'react'

const SvgOrders = props => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path d="M7.546 12.048h7.091v1.81H7.546v-1.81zm1.773 7.238H5.773V4.81h6.205v4.523h4.432v2.805l1.773-1.81v-1.9L12.864 3H5.773c-.47 0-.921.19-1.254.53-.332.34-.519.8-.519 1.28v14.476c0 .48.187.94.52 1.28.332.339.783.53 1.253.53h3.546v-1.81zm-1.773-1.81h3.634l.798-.814v-.995H7.546v1.81zm10.814-4.524c.089 0 .266.09.355.181l1.152 1.177c.177.18.177.542 0 .723l-.886.905-1.862-1.9.887-.905c.088-.09.177-.18.354-.18zm0 3.529L12.953 22H11.09v-1.9l5.408-5.519 1.861 1.9z" />
    </svg>
)

export default SvgOrders
